import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { EventType, PlatformEvent } from "../common/Exports";
export var SpeechRecognitionEvent = /*#__PURE__*/function (_PlatformEvent) {
  _inherits(SpeechRecognitionEvent, _PlatformEvent);

  function SpeechRecognitionEvent(eventName, requestId, sessionId) {
    var _this;

    var eventType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : EventType.Info;

    _classCallCheck(this, SpeechRecognitionEvent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SpeechRecognitionEvent).call(this, eventName, eventType));
    _this.privRequestId = requestId;
    _this.privSessionId = sessionId;
    return _this;
  }

  _createClass(SpeechRecognitionEvent, [{
    key: "requestId",
    get: function get() {
      return this.privRequestId;
    }
  }, {
    key: "sessionId",
    get: function get() {
      return this.privSessionId;
    }
  }]);

  return SpeechRecognitionEvent;
}(PlatformEvent); // tslint:disable-next-line:max-classes-per-file

export var RecognitionTriggeredEvent = /*#__PURE__*/function (_SpeechRecognitionEve) {
  _inherits(RecognitionTriggeredEvent, _SpeechRecognitionEve);

  function RecognitionTriggeredEvent(requestId, sessionId, audioSourceId, audioNodeId) {
    var _this2;

    _classCallCheck(this, RecognitionTriggeredEvent);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(RecognitionTriggeredEvent).call(this, "RecognitionTriggeredEvent", requestId, sessionId));
    _this2.privAudioSourceId = audioSourceId;
    _this2.privAudioNodeId = audioNodeId;
    return _this2;
  }

  _createClass(RecognitionTriggeredEvent, [{
    key: "audioSourceId",
    get: function get() {
      return this.privAudioSourceId;
    }
  }, {
    key: "audioNodeId",
    get: function get() {
      return this.privAudioNodeId;
    }
  }]);

  return RecognitionTriggeredEvent;
}(SpeechRecognitionEvent); // tslint:disable-next-line:max-classes-per-file

export var ListeningStartedEvent = /*#__PURE__*/function (_SpeechRecognitionEve2) {
  _inherits(ListeningStartedEvent, _SpeechRecognitionEve2);

  function ListeningStartedEvent(requestId, sessionId, audioSourceId, audioNodeId) {
    var _this3;

    _classCallCheck(this, ListeningStartedEvent);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ListeningStartedEvent).call(this, "ListeningStartedEvent", requestId, sessionId));
    _this3.privAudioSourceId = audioSourceId;
    _this3.privAudioNodeId = audioNodeId;
    return _this3;
  }

  _createClass(ListeningStartedEvent, [{
    key: "audioSourceId",
    get: function get() {
      return this.privAudioSourceId;
    }
  }, {
    key: "audioNodeId",
    get: function get() {
      return this.privAudioNodeId;
    }
  }]);

  return ListeningStartedEvent;
}(SpeechRecognitionEvent); // tslint:disable-next-line:max-classes-per-file

export var ConnectingToServiceEvent = /*#__PURE__*/function (_SpeechRecognitionEve3) {
  _inherits(ConnectingToServiceEvent, _SpeechRecognitionEve3);

  function ConnectingToServiceEvent(requestId, authFetchEventid, sessionId) {
    var _this4;

    _classCallCheck(this, ConnectingToServiceEvent);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(ConnectingToServiceEvent).call(this, "ConnectingToServiceEvent", requestId, sessionId));
    _this4.privAuthFetchEventid = authFetchEventid;
    return _this4;
  }

  _createClass(ConnectingToServiceEvent, [{
    key: "authFetchEventid",
    get: function get() {
      return this.privAuthFetchEventid;
    }
  }]);

  return ConnectingToServiceEvent;
}(SpeechRecognitionEvent); // tslint:disable-next-line:max-classes-per-file

export var RecognitionStartedEvent = /*#__PURE__*/function (_SpeechRecognitionEve4) {
  _inherits(RecognitionStartedEvent, _SpeechRecognitionEve4);

  function RecognitionStartedEvent(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId) {
    var _this5;

    _classCallCheck(this, RecognitionStartedEvent);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(RecognitionStartedEvent).call(this, "RecognitionStartedEvent", requestId, sessionId));
    _this5.privAudioSourceId = audioSourceId;
    _this5.privAudioNodeId = audioNodeId;
    _this5.privAuthFetchEventId = authFetchEventId;
    return _this5;
  }

  _createClass(RecognitionStartedEvent, [{
    key: "audioSourceId",
    get: function get() {
      return this.privAudioSourceId;
    }
  }, {
    key: "audioNodeId",
    get: function get() {
      return this.privAudioNodeId;
    }
  }, {
    key: "authFetchEventId",
    get: function get() {
      return this.privAuthFetchEventId;
    }
  }]);

  return RecognitionStartedEvent;
}(SpeechRecognitionEvent);
export var RecognitionCompletionStatus;

(function (RecognitionCompletionStatus) {
  RecognitionCompletionStatus[RecognitionCompletionStatus["Success"] = 0] = "Success";
  RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceError"] = 1] = "AudioSourceError";
  RecognitionCompletionStatus[RecognitionCompletionStatus["AudioSourceTimeout"] = 2] = "AudioSourceTimeout";
  RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchError"] = 3] = "AuthTokenFetchError";
  RecognitionCompletionStatus[RecognitionCompletionStatus["AuthTokenFetchTimeout"] = 4] = "AuthTokenFetchTimeout";
  RecognitionCompletionStatus[RecognitionCompletionStatus["UnAuthorized"] = 5] = "UnAuthorized";
  RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectTimeout"] = 6] = "ConnectTimeout";
  RecognitionCompletionStatus[RecognitionCompletionStatus["ConnectError"] = 7] = "ConnectError";
  RecognitionCompletionStatus[RecognitionCompletionStatus["ClientRecognitionActivityTimeout"] = 8] = "ClientRecognitionActivityTimeout";
  RecognitionCompletionStatus[RecognitionCompletionStatus["UnknownError"] = 9] = "UnknownError";
})(RecognitionCompletionStatus || (RecognitionCompletionStatus = {})); // tslint:disable-next-line:max-classes-per-file


export var RecognitionEndedEvent = /*#__PURE__*/function (_SpeechRecognitionEve5) {
  _inherits(RecognitionEndedEvent, _SpeechRecognitionEve5);

  function RecognitionEndedEvent(requestId, audioSourceId, audioNodeId, authFetchEventId, sessionId, serviceTag, status, error) {
    var _this6;

    _classCallCheck(this, RecognitionEndedEvent);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(RecognitionEndedEvent).call(this, "RecognitionEndedEvent", requestId, sessionId, status === RecognitionCompletionStatus.Success ? EventType.Info : EventType.Error));
    _this6.privAudioSourceId = audioSourceId;
    _this6.privAudioNodeId = audioNodeId;
    _this6.privAuthFetchEventId = authFetchEventId;
    _this6.privStatus = status;
    _this6.privError = error;
    _this6.privServiceTag = serviceTag;
    return _this6;
  }

  _createClass(RecognitionEndedEvent, [{
    key: "audioSourceId",
    get: function get() {
      return this.privAudioSourceId;
    }
  }, {
    key: "audioNodeId",
    get: function get() {
      return this.privAudioNodeId;
    }
  }, {
    key: "authFetchEventId",
    get: function get() {
      return this.privAuthFetchEventId;
    }
  }, {
    key: "serviceTag",
    get: function get() {
      return this.privServiceTag;
    }
  }, {
    key: "status",
    get: function get() {
      return this.privStatus;
    }
  }, {
    key: "error",
    get: function get() {
      return this.privError;
    }
  }]);

  return RecognitionEndedEvent;
}(SpeechRecognitionEvent);